import React from 'react';

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

const TYPE_LABELS = { CALL: 'Call', EMAIL: 'Email', MEETING: 'Meeting' };

export default function ActivityFeed({ activities = [] }) {
  const recent = [...activities]
    .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''))
    .slice(0, 10);

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b">
        <h2 className="text-lg font-semibold text-gray-900">Recent Activity</h2>
      </div>
      <div className="p-6">
        {recent.length === 0 ? (
          <p className="text-gray-500 text-center py-6">No activities yet.</p>
        ) : (
          recent.map((a) => (
            <div key={a.id} className="flex gap-3 py-3 border-b last:border-b-0">
              <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
              <div>
                <p className="text-gray-900">
                  <span className="font-medium">{TYPE_LABELS[a.type] || a.type}</span>
                  {' — '}{a.subject}
                  {a.dealName && <> · <span className="text-gray-600">{a.dealName}</span></>}
                </p>
                <p className="text-sm text-gray-500 mt-1">{timeAgo(a.createdAt)}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
